import { sagaDevMiddleware, configureDevStore } from './configureStore.dev';
import { sagaProdMiddleware, configureProdStore } from './configureStore.prod';

export const configureStore =
    process.env.REACT_APP_ENV === 'production'
        ? configureProdStore
        : configureDevStore;
export const sagaMiddleware =
    process.env.REACT_APP_ENV === 'production'
        ? sagaProdMiddleware
        : sagaDevMiddleware;



// WEBPACK FOOTER //
// ./src/store/configureStore.js